import { useState, useEffect, useRef, useContext  } from 'react'
import { useDispatch, connect } from "react-redux";
import { Draggable, Droppable } from "react-beautiful-dnd";
import Card from "./card";
import { Row, Dropdown, Button, Spinner } from "react-bootstrap";
import { StageInlineEdit } from '../../../../components/StageInlineEdit.js';
import { CheckIcon, EditStageDropdown } from '../../../../components';
import NewContentGroupSingleFieldForm from '../../ContentGroupPage/newSingleFieldForm'
import { stageActions, content_groupActions, alertActions } from "../../../../actions";
import InfiniteScroll from 'react-infinite-scroll-component';
import { WorkspaceShowContext } from "../../../../contexts/WorkspaceShowContext";
import { PerPageContentGroup, CircleAddIcon } from '../../../../components';
import { useIsVisible } from '../../../../utils/useIsVisible';
import { TimeIcon } from '@mui/x-date-pickers';
import { TimeTrackIcon } from '../../../../components/icons/TimeTrackIcon.js';
import { StageSettingsIcon } from '../../../../components/stage/StageSettingsIcon.js';
import { userConstants } from '../../../../constants/user.constants.js';
import { stageConstants } from '../../../../constants/stage.constants.js';

function CardGroup(props) {
  const {
    column,
    index,
    can_crud_content_group,
    workspace_id,
    organization_id,
    can_access_move_content_board,
    can_access_edit_title,
    can_access_move_stage_board,
    can_access_show_content_details,
    can_access_approval_dots,
    updated_content_group,
    currentSearchText,
    can_access_edit_label,
    stages_to_reload
  } = props;
  const [showAddContentGroupField, setShowAddContentGroupField] = useState(false);
  const dispatch = useDispatch();
  const addContentGroupRowRef = useRef();
  const [loading, setLoading] = useState(false);
  const perPage = PerPageContentGroup;
  const stageRef = useRef();
  const isVisible = useIsVisible(stageRef);
  const [initialLoaded, setInitialLoaded] = useState(false);
  const [editModeCatcher, setEditModeCatcher] = useState(false);
  const loading_ref = useRef(loading)

  const addContentGroups = (result) => {
    const reset_content_group = false;
    addContentGroupToStage(column, result.content_groups, result.total_pages, result.has_next_page, reset_content_group)
  }

  const resetContentGroups = (result) => {
    const reset_content_group = true;
    addContentGroupToStage(column, result.content_groups, result.total_pages, result.has_next_page, reset_content_group)
  }

  const loadNextPageContentGroups = (result) => {
    const reset_content_group = true;
    addContentGroupToStage(column, result.content_groups, result.total_pages, result.has_next_page, reset_content_group)
  }

  const {
    can_access_stage,
    can_access_content,
    can_access_sort_stage,
    nextPage,
    addContentGroupToStage,
    resetStage,
    removeContentGroupToStage,
    replaceContentGroupToStage,
    handleSortByDueDateStage,
    handleOpenContentGroupPopUp,
    handleShowDeleteStagePopup,
    refreshContentGroupToStage,
    loadTracker,
    query
  } = useContext(WorkspaceShowContext);

  const refreshListPaginate = (result) => {
    refreshContentGroupToStage(column, result.content_groups)
  }

  useEffect(() => {
    loading_ref.current = loading
  }, [loading]);

  useEffect(() => {
    if(props?.created_content_group && column?.id === props?.created_content_group.stage_id){
      addContentGroupToStage(column, [props.created_content_group], column.total_pages)
    }
  }, [props?.created_content_group]);

  useEffect(() => {
    if(props?.destroyed_content_group && column?.id == props?.destroyed_content_group.stage_id){
      removeContentGroupToStage(column, props.destroyed_content_group)
    }
  }, [props?.destroyed_content_group]);

  useEffect(() => {
    if(column && isVisible && column?.page > 1){
      dispatch(stageActions.listPaginate(workspace_id, column?.id, addContentGroups, setLoading, column?.page, perPage, currentSearchText));
    }
  }, [column?.page]);

  useEffect(() => {
    if(loading_ref.current) return;

    if (currentSearchText !== '' || !isVisible) {
      setInitialLoaded(false)
    } else {
      setInitialLoaded(true)
    }
    if(column && isVisible){
      resetStage(column);
      dispatch(stageActions.listPaginate(workspace_id, column?.id, resetContentGroups, setLoading, column?.page, perPage, currentSearchText));
    }
  }, [currentSearchText]);

  useEffect(() => {
    if(isVisible && !initialLoaded && column?.page === 1){
      const search = query.get('search');
      dispatch(stageActions.listPaginate(workspace_id, column?.id, resetContentGroups, setLoading, 1, perPage, search));
      setInitialLoaded(true);
    } else if(isVisible && initialLoaded){
      console.log("Card Group isVisible refreshListPaginate")
      const onSuccess = (response) => {
        dispatch({ type: stageConstants.REFRESH_STAGE, payload: response.data });
      }

      const onError = (response) => { 
        dispatch({ type: userConstants.STAGE_FAILURE, payload: response.data.error});
        dispatch(alertActions.error(response.data.message));
      }
      dispatch(stageActions.refreshListPaginate({
                                                  workspace_id, 
                                                  stage_id: column?.id, page: 1, 
                                                  per_page: column?.page * perPage, 
                                                  currentSearchText,
                                                  onSuccess,
                                                  onError 
                                                }));
    }
  }, [isVisible]);

  useEffect(() => {
    const stage_id = column?.id;
    const needsToReload = stages_to_reload?.findIndex(s => s.id === stage_id) !== -1;

    if(needsToReload && isVisible){
      const onSuccess = (response) => {
        refreshContentGroupToStage(column, response.data.content_groups)
      }

      const onError = (response) => { 
        dispatch({ type: userConstants.STAGE_FAILURE, payload: response.data.error});
        dispatch(alertActions.error(response.data.message));
      }
      dispatch(stageActions.refreshListPaginate({
                                                  workspace_id, 
                                                  stage_id: column?.id, 
                                                  page: 1, 
                                                  per_page: column?.page * perPage, 
                                                  currentSearchText,
                                                  onSuccess,
                                                  onError
                                                }));
    }
  }, [stages_to_reload]);

  useEffect(() => {
    if (updated_content_group) {
      let current_content_group_index = column?.items.findIndex(r => r.id === updated_content_group.id)

      if (current_content_group_index !== -1) {
        if (updated_content_group) {
          if (column?.id != updated_content_group.stage_id) {
            removeContentGroupToStage(column, updated_content_group)
          } else {
            replaceContentGroupToStage(column, updated_content_group)
          }
        }
      } else {
        if (column?.id == updated_content_group.stage_id) {
          addContentGroupToStage(column, updated_content_group)
        }
      }
    }
  }, [updated_content_group]);

  useEffect(() => {
    if(isVisible && initialLoaded && loadTracker && !loading_ref.current){
      const onSuccess = (response) => {
        dispatch({ type: stageConstants.REFRESH_STAGE, payload: response.data });
      }

      const onError = (response) => { 
        dispatch({ type: userConstants.STAGE_FAILURE, payload: response.data.error});
        dispatch(alertActions.error(response.data.message));
      }
      dispatch(stageActions.refreshListPaginate({
                                                  workspace_id, 
                                                  stage_id: column?.id, 
                                                  page: 1, 
                                                  per_page: column?.page * perPage, 
                                                  currentSearchText,
                                                  onSuccess,
                                                  onError
                                                }));
    }
 }, [loadTracker]);

  const handleInlineEdit = (handleOnBlur, values, workspace_id, stage_id) => {
     if(can_access_edit_title) {
      dispatch(stageActions.inlineEditStage(handleOnBlur, values, workspace_id, stage_id));
    }else {
      dispatch(alertActions.error("You are not authorized to access this page"));
    }
  }

  const handleShowNewForm = () => {
    setShowAddContentGroupField(true);
  };

  const handleCloseNewForm = () => {
    setShowAddContentGroupField(false);
  }

  const handleCreateContentGroupSuccess = (id) => {
    setShowAddContentGroupField(false)
  };

  const handleNewContentGroupSubmit = (values) => {
    dispatch(content_groupActions.createContentGroup(values, workspace_id, handleCreateContentGroupSuccess));
  };

  const stageHeaderRef = useRef(null);
  const inactiveSearchText = currentSearchText === '' || currentSearchText === null || currentSearchText === undefined;

  return (
    <div
      className="kanban-board"
      ref={stageRef}
    >
      <Draggable
        draggableId={"column-"+column.id.toString()}
        index={index}
        key={"board-"+column.id.toString()}
        isDragDisabled={can_access_move_stage_board ? false : true}
      >
        {(provided, snapshot) => {
          return (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              className={ "kanban-card-group me-1" + 
                (column.items && column.items.length == 0 ? " kanban-card-group--empty" : "") + (column?.visible_to_client ? " kanban-card-group--visible-to-client" : "") 
              }
              style={{
                userSelect: "none",
                ...provided.draggableProps.style,
              }}
            >

            <div 
              className='kanban-card-group__container'
              style={{
                maxHeight: `calc(100% - 50px)`,
              }}
              {...provided.dragHandleProps}
            >
              <div
                className={`kanban-card-group_header d-flex justify-content-between position-relative`}
              >
                <div ref={stageHeaderRef} className="w-100 d-flex align-items-center position-relative">
                  {
                    //can_crud_content_group ?
                    can_access_edit_title ?
                      <StageInlineEdit
                        stage={column}
                        value={column.name}
                        edit_type="name"
                        can_access_edit_title={can_access_edit_title}
                        handleInlineEdit={(handleOnBlur, name) => handleInlineEdit(handleOnBlur, name, workspace_id, column.id)}
                        inputFocusWidth={180}
                      />
                    :
                      <h2 className="h4 mb-0 w-100 scrollable-heading">
                        { column.name }
                      </h2>
                  }
                </div>
                <div className="d-flex align-items-center justify-content-between me-3">
                  <StageSettingsIcon 
                    stage={column} 
                    isVisible={can_access_approval_dots}
                  />
                </div>

                {
                  (can_access_stage || can_access_content || can_access_sort_stage) &&
                  <EditStageDropdown
                    stage={column}
                    inactiveSearchText={inactiveSearchText}
                    setShowAddContentGroupField={setShowAddContentGroupField}
                    className={"position-absolute"}
                  />
                }
              </div>

              <Droppable
                droppableId={column.id.toString()}
                key={column.id}
                type="CARD"
              >
                {(dropProvided, dropSnapshot) => {
                  return (
                    <div
                      ref={dropProvided.innerRef}
                      style={{
                        background: dropSnapshot.isDraggingOver
                          ? "lightgrey"
                          : "none",
                        width: 260,
                        minHeight: 2,
                        borderRadius: '8px',
                        display: 'flex',
                        maxHeight: `calc(100% - 37px)`,
                      }}
                    >
                      <InfiniteScroll
                        dataLength={column?.items?.length}
                        hasMore={loading ? false : column?.has_next_page}
                        loader={
                          <div className="clearfix">
                            <div className="spinner-container">
                              <Spinner animation="border" />
                            </div>
                          </div>
                        }
                        height={ '100%' }
                        className="vertical-scroll_thin no-bg"
                        next={() => nextPage(column)}
                      >
                        {
                          column?.items?.length > 0 && (
                            column?.items.map((item, index) => {
                              return (
                                <Card
                                  item={item}
                                  index={index}
                                  key={item.id}
                                  stage={column}
                                  can_crud_content_group={can_crud_content_group}
                                  workspace_id={workspace_id}
                                  organization_id={organization_id}
                                  can_access_content={can_access_content}
                                  can_access_move_content_board={can_access_move_content_board}
                                  can_access_show_content_details={can_access_show_content_details}
                                  can_access_edit_label={can_access_edit_label}
                                />

                              );
                            })
                          )
                        }
                        {dropProvided.placeholder}
                      </InfiniteScroll>
                      {dropProvided.placeholder}
                    </div>
                  );
                }}
              </Droppable>
            </div>

            

              { !can_crud_content_group && column.items && column.items.length == 0 &&
                <div className="kanban-column__no-cards">
                  No Queue
                </div>
              }


              {can_access_content && inactiveSearchText &&(
                <div
                  className="add-content_container"
                  style={{userSelect: "none"}}
                  ref={addContentGroupRowRef}
                >
                  { showAddContentGroupField ?
                      <NewContentGroupSingleFieldForm
                        handleClose={ handleCloseNewForm }
                        onSubmit={ handleNewContentGroupSubmit }
                        handleOpenContentGroupPopUp={ handleOpenContentGroupPopUp }
                        addContentGroupRowRef={ addContentGroupRowRef }
                        stageId={ column.id } 
                        workspace_id={workspace_id}
                      />
                    :
                      <div className="d-grid">
                        <Button 
                          variant={'dashed'}
                          onClick={() => setShowAddContentGroupField(true)}
                          size={'sm'}
                          className='add-trigger-button'
                        >
                          Add Card
                        </Button>
                      </div>
                  }
                </div>
              )}
            </div>
          );
        }}
      </Draggable>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    created_content_group: state.content_group.created_content_group,
    destroyed_content_group: state.content_group.destroyed_content_group,
    updated_content_group: state.content_group.updated_content_group,
    currentSearchText: state.search_history.current_search_text,
    stages_to_reload: state.stage.stages_to_reload,
  };
};

export default connect(mapStateToProps, {})(CardGroup);
